import { makeAutoObservable } from "mobx";
import { v4 as uuidv4 } from "uuid";

import { MealKind, PlannedMealAttributes } from "@/gql/graphql";
import { formatISOTimeOfDay } from "@/utils/datetime";
import { humanize } from "@/utils/string";

import { Cell } from "./Cell";
import MealPlanFormStore from "./MealPlanFormStore";
import { PlannedMealItem } from "./PlannedMealItem";

export class PlannedMeal {
  uuid: string;
  meal: MealKind;
  recommendedTime: Date;

  private store: MealPlanFormStore;

  get label(): string {
    return humanize(this.meal);
  }

  /**
   * Cells of this planned meal, already sorted by day.
   */
  get cells(): Cell[] {
    return this.store.dayColumns.map((day) => this.store.cells.get(day, this));
  }

  get items(): PlannedMealItem[] {
    return this.cells.flatMap((cell) => cell.items);
  }

  constructor(
    store: MealPlanFormStore,
    meal: MealKind,
    recommendedTime: Date,
    uuid = uuidv4()
  ) {
    makeAutoObservable(this);
    this.uuid = uuid;
    this.meal = meal;
    this.recommendedTime = recommendedTime;
    this.store = store;
  }

  setMeal(meal: MealKind): void {
    this.meal = meal;
  }

  setRecommendedTime(recommendedTime: Date): void {
    this.recommendedTime = recommendedTime;
  }

  remove(): void {
    this.store.plannedMealRows.remove(this);
  }

  toAttributes(): PlannedMealAttributes {
    return {
      uuid: this.uuid,
      meal: this.meal,
      recommendedTime: formatISOTimeOfDay(this.recommendedTime),
      syncItemsAttributes: this.items.map((item) => item.toAttributes()),
    };
  }
}
